import { ErrorHandler, LOCALE_ID, NgModule, inject, provideAppInitializer } from '@angular/core';
import {registerLocaleData} from '@angular/common';
import {ThermostatcheckRoutingModule} from './thermostatcheck-routing.module';
import {TranslateLoader, provideTranslateService} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {BrowserModule} from '@angular/platform-browser';
import {HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import * as Sentry from '@sentry/angular';
import {Router} from '@angular/router';
import localeDE from '@angular/common/locales/de';
import {ThermostatcheckComponent} from './thermostatcheck.component';
import {EinstiegComponent} from './einstieg/einstieg.component';
import {EingabeStartComponent} from './eingabe/eingabe.start.component';
import {StepService} from '../services/step.service';
import {AdvisorSharedModule} from '../advisor.shared.module';
import {EingabeStepComponent} from './eingabe/eingabe.step.component';
import {ErgebnisComponent} from './ergebnis/ergebnis.component';
import {PortalService} from '../services/portal.service';
import {MatButtonModule} from '@angular/material/button';
import {ThermostatcheckAusstiegComponent} from "./eingabe/thermostatcheck.ausstieg.component";
import {MatTabsModule} from "@angular/material/tabs";
import {HeizcheckModule} from "../heizcheck/heizcheck.module";

// global definition of language prefixe
declare let advisorTranslationPrefix;

// AoT requires an exported function for factories
export function HttpLoaderFactory() {
  const http = inject(HttpClient);
  return {
    getTranslation: (lang: string) => http.get<object>(
      (typeof advisorTranslationPrefix !== 'undefined' ? advisorTranslationPrefix : 'translations/' + PortalService.defaultPortal + '/thermostatcheck/') + lang + '.json'
    )
  };
}

// load the locales dynamic, based on the users browser language with fallback
const browserLocale = getBrowsersLocale();
switch (browserLocale.substring(0, 2)) {
  case 'de':
    registerLocaleData(localeDE, 'de');
    break;
}

/**
 * returns the users locale from the browser
 */
function getBrowsersLocale() {
  /* tslint:disable:no-string-literal */
  if (navigator['browserLanguage']) {
    return navigator['browserLanguage'];
  }
  else if (navigator.language) {
    return navigator.language;
  }
  /* tslint:enable:no-string-literal */
}

@NgModule({
  declarations: [
    ThermostatcheckComponent,
    EinstiegComponent,
    EingabeStartComponent,
    EingabeStepComponent,
    ThermostatcheckAusstiegComponent,
    ErgebnisComponent,
  ],
  bootstrap: [
    ThermostatcheckComponent
  ],
  imports: [
    BrowserModule,
    ThermostatcheckRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    AdvisorSharedModule,
    MatButtonModule,
    MatTabsModule,
    HeizcheckModule
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
    {provide: LOCALE_ID, useValue: getBrowsersLocale()},
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
        dialogOptions: {
          user: {
            name: 'dummy',
            email: 'dummy@co2online.de'
          }
        }
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      const initializerFn = () => {
        inject(Sentry.TraceService)
      };
        return initializerFn();
      }),
    StepService,
        provideTranslateService({loader: {provide: TranslateLoader, useFactory: HttpLoaderFactory}}),
        provideHttpClient(withInterceptorsFromDi())
  ]
})
export class ThermostatcheckModule {
}
